import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../redux/auth/actions";

const AutoLogout: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const inactivityLimit = 30 * 60 * 1000; // 30 minutos de inactividad
  //const inactivityLimit = 1 * 60 * 1000; // 1 minuto de inactividad

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      dispatch(logoutUser());
    }, inactivityLimit);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dispatch]);

  return <>{children}</>;
};

export default AutoLogout;
